import {Button, Typography} from "@mui/material";
import KeycloakService from "../KeycloakService";
import {useTranslation} from "react-i18next";


export default function Welcome() {
  const {t} = useTranslation()
  return (
    <div>
      <Typography variant="h1" color={'primary'}
                  sx={{fontFamily: 'poppins', textAlign: 'center', paddingTop: '5%'}}>{t('pages.welcomePage.h1')}</Typography>
      <Typography variant="h4" color={'primary'} sx={{fontFamily: 'poppins', textAlign: 'center'}}>
        {t('pages.welcomePage.h4')}
      </Typography>

      <Button sx={{margin: '0 auto', marginTop: 3, display: 'flex'}} variant={'contained'}
              onClick={() => KeycloakService.instance.doLogin()}>{t('pages.welcomePage.loginButton')}</Button>

    </div>
  )
}
